<template>
  <main class="container">
      <h1>Vue SPA App</h1>
  </main>
</template>